import React, { ReactElement } from 'react'
import Image from '../../../components/imgix-img'

interface GuestAuthorTagProps {
  companyLogoUrl: string
}

const GuestAuthorTag = ({ companyLogoUrl }: GuestAuthorTagProps): ReactElement => {
  return (
    <div className='guestAuthorTag'>
      <span className='guestAuthorTag__text'>Guest author from</span>
      <Image
        className='guestAuthorTag__logo'
        src={companyLogoUrl}
        alt={'guest-author-company-logo'}
        critical={false}
        width={150}
      />
    </div>
  )
}

export default GuestAuthorTag
